import { PropsWithChildren, useEffect, useState, useRef, FC } from 'react';
import { DateFormatted, Typography, Anchor } from '@ui/components';
import { Indicator } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';

export interface NotificationsFooterProps extends PropsWithChildren {
  createdAt: string | Date;
}

export const NotificationsFooter: FC<NotificationsFooterProps> = ({ children, createdAt }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = parseInt(window.getComputedStyle(contentRef.current).lineHeight);
      const height = contentRef.current.scrollHeight;
      const lines = height / lineHeight;
      setShouldShowButton(lines > 2);
    }
  }, [children]);

  return (
    <>
      <div className={`leading-normal ${isExpanded ? '' : 'line-clamp-2'}`} ref={contentRef}>
        {children}
      </div>

      <div className="flex justify-between items-center mt-2">
        <div className="flex gap-2 items-center text-disabled">
          <Typography variant="labelSmallBook" asChild>
            <DateFormatted format="DATE_SHORT" date={createdAt} />
          </Typography>

          <Indicator />

          <Typography variant="labelSmallBook" asChild>
            <DateFormatted format="TIME_24_SIMPLE" date={createdAt} />
          </Typography>
        </div>

        {shouldShowButton && !isExpanded && (
          <Anchor onClick={() => setIsExpanded(!isExpanded)} className="w-fit block">
            {t('NOTIFICATIONS.SHOW_MORE')}
          </Anchor>
        )}
      </div>
    </>
  );
};
